import React from 'react';
import './SectionLabel.css';

interface Props { text: string; }

const SectionLabel: React.FC<Props> = ({ text }) => (
  <div className="section-label">
    <span className="section-label__line" />
    {text}
  </div>
);

export default SectionLabel;